import styled from "styled-components";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { FaqAccordion } from "./Accordions";
import { SubTitle } from "./SessionPageComponents";
import {
  descentFaqItems,
  getDescentFaqPreviewItems,
} from "../data/DescentFaq";

export const DescentFaqSection = ({ preview }) => {
  const items = preview ? getDescentFaqPreviewItems() : descentFaqItems;

  return (
    <FaqSection $withTitle={preview}>
      {preview ? <SubTitle>Q&A</SubTitle> : null}
      {preview ? <br /> : null}
      <FaqAccordion items={items} />
      {preview ? (
        <NavLinkWrap>
          <DescentPageLink to="/the-descent/qa">
            <LinkLabel>Check all Descent Q&A</LinkLabel>
            <LinkArrow $trailing>→</LinkArrow>
          </DescentPageLink>
        </NavLinkWrap>
      ) : null}
    </FaqSection>
  );
};

export const descentSectionDivider = `
  border-top: 1px solid rgba(255, 255, 255, 0.14);
`;

const FaqSection = styled.section`
  margin: ${({ $withTitle }) => ($withTitle ? "0 0 2rem" : "4rem 0 2rem")};
  padding-top: ${({ $withTitle }) => ($withTitle ? "2rem" : "0")};
  ${descentSectionDivider}

  @media screen and (max-width: 600px) {
    padding-top: ${({ $withTitle }) => ($withTitle ? "3.5rem" : "0")};
  }
`;

export const LinkLabel = styled.span`
  letter-spacing: 0.22em;

  @media screen and (max-width: 600px) {
    letter-spacing: 0.16em;
  }
`;

export const LinkArrow = styled.span`
  letter-spacing: 0;
  margin-left: ${({ $trailing }) => ($trailing ? "0.35em" : "0")};
  margin-right: ${({ $leading }) => ($leading ? "0.35em" : "0")};
`;

export const DescentPageLink = styled(Link)`
  display: inline-block;
  font-family: "Ysabeau", sans-serif;
  font-size: 1rem;
  font-weight: 300;
  text-transform: uppercase;
  text-decoration: none;
  border-bottom: 1px solid var(--color-bone);
  padding-bottom: 0.35em;
  color: var(--color-bone);
  transition: opacity 200ms ease;

  &:hover {
    opacity: 0.75;
  }

  @media screen and (max-width: 600px) {
    font-size: 1.05rem;
  }
`;

export const NavLinkWrap = styled.p`
  text-align: center;
  margin: ${({ $margin }) => $margin ?? "3rem 0 0"};
`;
